import { LibraryCache } from './types/domain.types';

export const globalLibraryCache: LibraryCache = {};
